'use client';
import * as TC from './components';
import * as deprecated from './deprecated';
import * as Tokens from './tokens';
import { ThemeNames } from './themes';
import ThemeProvider, { getTheme } from './ThemeProvider';
import Theme from './types/theme';
import ThemedProps from './types/themeProps';
import ColorBlindModes from './types/theme/colorBlindModes';
import useTheme from './useTheme';
import styled, { css, createGlobalStyle, keyframes, ThemeConsumer, ThemeContext } from './ThemeStyle';
import * as StyledComponents from 'styled-components';
import { BeeZ } from './BeeZ';
import { StyleSheetManager } from './StyleSheetManager';

const hueToColor = (hue: number): string => `hsla(${hue}, 75%, 65%)`;
const hueToColorAlpha = (hue: number, alpha?: number): string => `hsla(${hue}, 75%, 65%, ${alpha ?? '0.4'})`;
const colorToHue = (color: string): number => parseInt(color.substring(5, color.indexOf(',')));

export {
  BeeZ,
  createGlobalStyle,
  colorToHue,
  css,
  deprecated,
  getTheme,
  keyframes,
  hueToColor,
  hueToColorAlpha,
  StyledComponents,
  StyleSheetManager,
  TC,
  ThemeContext,
  ThemeConsumer,
  ThemeProvider,
  Tokens,
  useTheme,
  styled,
};

export type { ColorBlindModes, Theme, ThemeNames, ThemedProps };

export default styled;
